import { Action, createReducer, on } from "@ngrx/store";

import * as PromptsActionTypes from "../../actions/prompts/prompts.actions";

import { PaginationRequest } from "src/app/models/common/paginationRequest";
import {
  PromptCategory,
  PromptDataType,
  PromptsDTO,
} from "src/app/models/Prompts/promptsDTO";
import { ColumnSorterInfo } from "src/app/models/custom-table/custom-table.model";

export interface PromptsState {
  prompts: Array<PromptsDTO>;
  dataTypes: PromptDataType[];
  categories: PromptCategory[];
  promptsTableConfig: ColumnSorterInfo[];
  error: string;
  pageReq: PaginationRequest;
  created: boolean;
  prompt: PromptsDTO;
  excelPrompts: PromptsDTO[];
  totalPrompts: number;
  isLoading: boolean;
}

export const initialState: PromptsState = {
  prompts: null,
  created: false,
  prompt: null,
  dataTypes: null,
  categories: null,
  promptsTableConfig: null,
  error: null,
  pageReq: null,
  excelPrompts: null,
  totalPrompts: null,
  isLoading: false,
};

const promptsReducer = createReducer(
  initialState,
  on(PromptsActionTypes.resetPromptsState, () => initialState),
  on(PromptsActionTypes.getPrompts, (state, { options }) => {
    return {
      ...state,
      options: options,
      isLoading: true,
    };
  }),
  on(PromptsActionTypes.loadPrompts, (state, { response }) => {
    return {
      ...state,
      prompts: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
      totalPrompts: (response as any)?.result?.size
        ? (response as any)?.result?.size
        : 0,
    };
  }),
  on(PromptsActionTypes.getExcelPrompts, (state, { options }) => {
    return {
      ...state,
      options: options,
      isLoading: true,
    };
  }),
  on(PromptsActionTypes.loadExcelPrompts, (state, { response }) => {
    return {
      ...state,
      excelPrompts: (response as any).result?.items
        ? (response as any).result?.items
        : undefined,
      error: null,
      isLoading: false,
    };
  }),
  on(
    PromptsActionTypes.getDataTypePrompts,
    (state, { pageReq }) =>
      ({
        ...state,
        error: null,
        pageReq: pageReq,
      } as PromptsState)
  ),
  on(PromptsActionTypes.loadDataTypePrompts, (state, { response }) => {
    return {
      ...state,
      dataTypes: (response as any).result.items || [],
      error: null,
    };
  }),
  on(
    PromptsActionTypes.getCategoriesPrompts,
    (state, { pageReq }) =>
      ({
        ...state,
        error: null,
        pageReq: pageReq,
      } as PromptsState)
  ),
  on(PromptsActionTypes.loadCategoriesPrompts, (state, { response }) => {
    return {
      ...state,
      categories: (response as any).result.items || [],
      error: null,
    };
  }),
  on(PromptsActionTypes.getPromptsTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(PromptsActionTypes.loadPromptsTableConfig, (state, { response }) => {
    return {
      ...state,
      promptsTableConfig:
        (response as any)?.result?.value?.tableColumnInfo ?? undefined,
    };
  }),
  on(PromptsActionTypes.savePromptsTableConfig, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(PromptsActionTypes.setPrompt, (state, { prompt }) => ({
    ...state,
    prompt: (prompt as any).result,
    isLoading: false,
    error: null,
  })),
  on(PromptsActionTypes.resetPrompt, (state) => {
    return {
      ...state,
      prompt: null,
      error: null,
    };
  }),
  on(PromptsActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(PromptsActionTypes.getPrompt, (state) => {
    return {
      ...state,
      isLoading: true,
      created: false,
    };
  }),
  on(PromptsActionTypes.resetCreation, (state) => {
    return {
      ...state,
      created: true,
    };
  }),
  on(
    PromptsActionTypes.createPrompts,
    PromptsActionTypes.updatePrompts,
    (state) => {
      return {
        ...state,
        isLoading: true,
      };
    }
  )
);

export function reducer(state: PromptsState | undefined, action: Action) {
  return promptsReducer(state, action);
}
